<template lang="pug">
  section.CollectionDrawerList.PageContent_section.PageContent-light-background
    .PageContent_wrapper

      .TitleSection
        h2 {{ title }}
        p {{ $tc('collection.drawers_collection', totalNumOfDrawers, { count: totalNumOfDrawers }) }}

      .CollectionDrawerList_items
        CollectionDrawerListItem(v-for="(item, index) in drawers", :key="item.id", :item="item")

      .CollectionDrawerList_more(v-if="!allDrawersFetched && isFetchingDrawers" key="loading")
        InfiniteScrollLoader
      .CollectionDrawerList_more(v-if="!allDrawersFetched && !isFetchingDrawers" @click="loadMoreDrawers" key="loadBtn" ref="loadingBtn") {{ $tc('collection.loading_more_drawers') }}
      .CollectionDrawerList_more(v-if="allDrawersFetched" key="loaded") {{ $tc('collection.all_drawers_loaded') }}
</template>

<script>

import DrawerModel from '@/models/DrawerModel'
import CollectionDrawerListItem from '@/components/CollectionDrawerListItem'
import raf from 'raf'
import InfiniteScrollLoader from '@/components/common/InfiniteScrollLoader'

export default {
  props: ['uuid', 'title'],
  components: {
    CollectionDrawerListItem,
    InfiniteScrollLoader
  },
  data () {
    return {
      drawers: [],
      isFetchingDrawers: false,
      totalNumOfDrawers: 0,
      pageIndex: 0,
      drawersByPage: 12
    }
  },
  computed: {
    nbOfDrawers () {
      return this.drawers.length
    },
    allDrawersFetched () {
      return this.nbOfDrawers === this.totalNumOfDrawers
    }
  },
  watch: {
    allDrawersFetched () {
      // Si tous les tiroirs ne sont pas encore chargés
      if (!this.allDrawersFetched) {
        this.stopWatchScroll()
        this.startWatchScroll()
      }
      // S'ils sont tous chargés
      else {
        this.stopWatchScroll()
      }
    }
  },
  mounted () {
    this.loadDrawers()
  },
  beforeDestroy () {
    // On arrêtre le raf
    this.stopWatchScroll()

    let p = this.$el.querySelectorAll('.CollectionDrawerListItem')

    for (let i = 0; i < p.length; i++) {
      this.$parallax.remove(p[i])
    }
  },
  methods: {
    loadMoreDrawers () {
      this.pageIndex++
      this.loadDrawers()
    },
    loadDrawers () {
      const offset = this.pageIndex * this.drawersByPage

      this.isFetchingDrawers = true

      this.$api.getCollectionDrawers(this.$i18n.locale, this.uuid, offset, this.drawersByPage)
        .then(response => {
          const d = response.data.data.map((drawer) => {
            return new DrawerModel(drawer, response.data.included)
          })

          this.drawers.splice(offset, this.drawersByPage, ...d)

          this.totalNumOfDrawers = parseInt(response.data.meta.count)

          this.isFetchingDrawers = false

          setTimeout(() => {
            let p = this.$el.querySelectorAll('.CollectionDrawerListItem')

            for (let i = 0; i < p.length; i++) {
              this.$parallax.set(p[i], { y: 0 }, { y: 90 }, { y: 15 })
            }
          }, 500)
        })
    },
    /**
     * Arrête d'écouter le scroll
     */
    stopWatchScroll () {
      if (this._watchScrollRaf) {
        this.$raf.cancel(this._watchScrollRaf)
        this._watchScrollRaf = null
      }
    },
    /**
     * Commence à écouter le scroll
     */
    startWatchScroll () {
      this._watchScrollRaf = this.$raf.create(this.watchScroll)
    },
    /**
     * Raf pour le scroll
     * afin de déterminer si le bouton permettant de charger les prochains tiroirs est visible à l'écran
     * dans quel cas on charge automatiquement les contenus
     */
    watchScroll () {
      let loadingBtnClientRect

      // Si on est pas déjà en train de charger de nouveaux tiroirs
      // Et si le bouton de chargement de tiroir existe
      if (!this.isFetchingDrawers && this.$refs.loadingBtn) {
        loadingBtnClientRect = this.$refs.loadingBtn.getBoundingClientRect()

        // Si le bouton est entièrement visible (dans la fenêtre du navigateur)
        if (loadingBtnClientRect.top < window.innerHeight - loadingBtnClientRect.height) {
          this.loadMoreDrawers()
        }
      }

      // this._watchScrollRaf = raf(this.watchScroll)
    }
  }
}

</script>

<style lang="stylus" scoped>

.CollectionDrawerList
  &_items

    display flex
    margin-top 35px
    flex-wrap wrap
    width 100%
    align-items: flex-start
    justify-content flex-start

    @media $mq_m
      margin-top 50px

    @media $mq_l
      margin-top 70px

  &_more

    position relative
    z-index 2
    margin 30px auto 0
    text-align center
    cursor pointer

    @media $mq_m
      margin 8.125vw auto 0

</style>
